import {
  useCreatePackaging,
  useDeletePackaging,
  useUpdatePackaging
} from "../../../../../../api/processGate/packaging";
import { PackagingMutations } from "../packagingLevel.types";

export const useProcessGatePackagingMutations = (): PackagingMutations => {
  const create = useCreatePackaging();
  const update = useUpdatePackaging();
  const remove = useDeletePackaging();

  return {
    create: { mutate: create.mutate, isLoading: create.isLoading },
    update: { mutate: update.mutate, isLoading: update.isLoading },
    delete: { mutate: remove.mutate, isLoading: remove.isLoading },
    isLoading: create.isLoading || update.isLoading || remove.isLoading
  };
};
